














import Vue from 'vue'
import { EventBus } from '@/Infrastructure/EventBus/EventBus'

export default Vue.extend({
  data () {
    return {
      loading: false
    }
  },
  computed: {
    smallIconUrl (): string {
      return require('@/UI/Assets/loader2.png')
    },
    bigIconUrl (): string {
      return require('@/UI/Assets/loader1.png')
    },
    loaderClass (): string {
      if (this.loading === null) {
        return ''
      }
      const loaderClass = this.loading === true
        ? 'fade-in-animation'
        : 'fade-out-animation'
      return loaderClass
    }
  },
  mounted () {
    EventBus.$on('loading', ($event: boolean) => {
      if (this.loading !== $event) {
        this.loading = $event
      }
    })
  }
})
